import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    layers: false, 
    zoomIn: false, 
    zoomOut: false,
    settingsActive: true,
};

const optionsSlice = createSlice({
    name: 'optionsSlice',
    initialState,
    reducers: {
        setOptions: (state, action) => {
            Object.keys(state).forEach((item) => {
                state[item] = false;
            });
            state[action.payload] = true;
            state.settingsActive = false;
        },
        reset: () => {
            return { ...initialState };
        },
    },
});

export default optionsSlice.reducer;

export const { 
    setOptions, 
    reset
} = optionsSlice.actions;